/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateUnarchivePathParams,
	WhatsAppTemplateUnarchiveResponse,
} from '../types/WhatsAppTemplateUnarchive'

/**
 * POST /organisations/:organisationId/whatsapp-templates/:templateId/unarchive
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::unarchive
 */
export async function whatsAppTemplateUnarchive(
	organisationId: WhatsAppTemplateUnarchivePathParams['organisationId'],
	templateId: WhatsAppTemplateUnarchivePathParams['templateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateUnarchiveResponse>> {
	return axiosInstance.post(
		`/organisations/${organisationId}/whatsapp-templates/${templateId}/unarchive`,
		undefined,
		config,
	)
}
